import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import SearchResultRowImpl from './search-result-row.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Search discovery result row.
 *
 * @class SearchResultRow
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SearchResultRow` prop types.
 *
 * @property {object} item - Search result to render. Holds `resultType`, `id`, `name`, `sportId` and,
 * depending on the type, optional fields such as `parentName`, `sportClassName`, `inPlay`, `startTime`,
 * `raceMeetingId` and `isOutright`.
 * @property {boolean} [isPlayerGroup = false] - Whether the result belongs to a player-prop group.
 * @property {Function} [onNavigate] - Called after result navigation.
 *
 * @memberof Mojito.Applications.Sports.Search.SearchResultRow
 */
const propTypes = {
    item: PropTypes.object.isRequired,
    isPlayerGroup: PropTypes.bool,
    onNavigate: PropTypes.func,
};

const defaultProps = {
    isPlayerGroup: false,
    onNavigate: noop,
};

export default UIView('SearchResultRow', SearchResultRowImpl, propTypes, defaultProps);
